import { AppFunctionComponent } from "../../../../../types"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import styled from "styled-components"
import { PrimaryHeading } from "../../../heading.component"
import { TextLink } from "../../../../../ui/components/link/link.component"
import { FullSection } from "../../section.component"
import InnovationLabFormUI from "./innovation-lab-form.component"
import { useLabForm } from "./use-lab-form.hook"
import { useLocalizationContext } from "../../../../../context/localization.context"
import {
  CustomComponentBuilder,
  QueryResultFlat,
  SingleQueryResult,
} from "../../../../../types"

const ThankYouWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
  padding-bottom: 90px;
  background-color: ${({ theme }) => theme.color.backgroundInverted};

  h2 {
    margin-bottom: 15px;
  }

  ${TextLink} {
    padding-top: 30px;
  }
`

const FullSectionWrapper = styled(FullSection)`
  padding-top: 90px;
  padding-bottom: 80px;
  background-color: ${({ theme }) => theme.color.backgroundAttentionLight};
`

export const ScrollAnchor = styled.span`
  position: absolute;
  top: 0;
  display: block;
  margin-top: -80px;
  margin-bottom: 80px;
`
export const INNOVATION_LAB_FORM = "innovation-lab-form"

const InnovationLab: AppFunctionComponent = () => {
  const {
    content: { nodes },
  }: SingleQueryResult<QueryResultFlat<CustomComponentBuilder>> =
    useStaticQuery(query)
  const { locale } = useLocalizationContext()
  const translatedContent =
    nodes.find((node) => node.node_locale === locale) || nodes[0]
  const { config } = translatedContent
  const { sentForm, onFormSubmit, submitAnotherIdea } = useLabForm()

  return (
    <>
      <ScrollAnchor id={INNOVATION_LAB_FORM} />
      {!sentForm ? (
        <InnovationLabFormUI config={config!} submitForm={onFormSubmit} />
      ) : (
        <FullSectionWrapper>
          <ThankYouWrapper data-testid="innovation-lab-thank-you">
            <PrimaryHeading renderAs="h2">
              Your idea was submitted!
            </PrimaryHeading>
            <p>We will get back to you within a few days.</p>
            <TextLink onClick={submitAnotherIdea}>Submit another idea</TextLink>
          </ThankYouWrapper>
        </FullSectionWrapper>
      )}
    </>
  )
}

const query = graphql`
  query InnovationLabFormCustomComponent {
    content: allContentfulCustomComponent(
      filter: { custom: { eq: "innovation lab form" } }
    ) {
      nodes {
        node_locale
        config {
          buttonText
          contactTitle
          downloadLinkText
          downloadLinkUrl
          email
          firstAndLastName
          id
          phoneNumber
          questionFields {
            inputs {
              sublabel
            }
            label
            maxChar
            sublabel
          }
          subtitle
          title
        }
      }
    }
  }
`

export default InnovationLab
